import { useEffect, useState } from 'react';
import { fetchContactInfo } from '../../api';
import './Contact.scss';

function Contact() {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    let mounted = true;
    fetchContactInfo().then((data) => {
      if (mounted) setInfo(data);
    });
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="contact">
      <section className="page-banner">
        <div className="container">
          <h1>联系我们</h1>
          <p>期待与您携手，共筑理想家</p>
        </div>
      </section>

      <section className="section">
        <div className="container contact-layout">
          {/* 联系信息 */}
          <div className="contact-info">
            <h2 className="section-title left">联系方式</h2>
            {info ? (
              <ul className="info-list">
                <li>
                  <span className="info-icon">📞</span>
                  <div>
                    <strong>客服热线</strong>
                    <p>{info.phone}</p>
                  </div>
                </li>
                <li>
                  <span className="info-icon">📧</span>
                  <div>
                    <strong>电子邮箱</strong>
                    <p>{info.email}</p>
                  </div>
                </li>
                <li>
                  <span className="info-icon">📍</span>
                  <div>
                    <strong>公司地址</strong>
                    <p>{info.address}</p>
                  </div>
                </li>
                <li>
                  <span className="info-icon">🕘</span>
                  <div>
                    <strong>营业时间</strong>
                    <p>{info.hours}</p>
                  </div>
                </li>
              </ul>
            ) : (
              <div className="page-loading">加载中...</div>
            )}
          </div>

          {/* 添加微信咨询 */}
          <div className="contact-wechat">
            <div className="wechat-card">
              <h3 className="wechat-title">添加微信咨询</h3>
              <p className="wechat-sub">扫码添加好美意专属顾问，获取一对一贴心服务</p>
              <div className="wechat-qr">
                <img src="/qd-wx.png" alt="好美意微信咨询二维码" />
              </div>
              <p className="wechat-tip">微信扫一扫，咨询更便捷</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
